import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const ProjectTypeButton = ({ className, Icon, title, onClick, ...restProps }) => {
  const styles = useStyles();

  return (
    <CustomButtonBase
      className={cx(styles.root, className)}
      onClick={onClick}
      {...restProps}
    >
      <Icon className={styles.icon} />

      <div className={styles.texts}>
        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {title}
        </CustomTypography>
      </div>
    </CustomButtonBase>
  );
};

ProjectTypeButton.propTypes = {
  className: PropTypes.string,
  Icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
ProjectTypeButton.defaultProps = {
  className: '',
};
